var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.485 15.89a3.808 3.808 0 0 1-5.375 0 3.808 3.808 0 0 1 0-5.375l3.36-3.359a3.802 3.802 0 0 1 5.159-.204.715.715 0 0 1-.93 1.086 2.354 2.354 0 0 0-3.222.126l-3.36 3.36c-.938.939-.938 2.42 0 3.358.94.94 2.42.94 3.36 0l3.19-3.19a.714.714 0 1 1 1.009 1.007l-3.191 3.19Zm6.046-6.046a3.802 3.802 0 0 1-5.16.204.715.715 0 1 1 .93-1.086c.939.808 2.326.77 3.222-.126l3.36-3.36c.939-.938.939-2.419 0-3.358-.94-.94-2.42-.94-3.36 0l-3.19 3.19a.712.712 0 1 1-1.009-1.007l3.191-3.19a3.808 3.808 0 0 1 5.375 0 3.808 3.808 0 0 1 0 5.374l-3.36 3.359Z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy_link.e2f579f6b3373f8d0c656c6e9f52408b.svg";
export { ForwardRef as ReactComponent };